import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { faCheckSquare, faSquare } from '@fortawesome/pro-light-svg-icons';
import { TranslocoService } from '@ngneat/transloco';
import { CompetenceModel } from 'projects/core/src/lib/models/competence.model';

type ValueType = {
  competence: CompetenceModel;
  selected: boolean;
};

@Component({
  selector: 'app-ac-competences',
  templateUrl: './ac-competences.component.html',
  styleUrls: ['./ac-competences.component.scss']
})
export class AcCompetencesComponent implements OnInit, OnChanges {

  @Input() competences: Array<CompetenceModel> = [];
  @Input() hidden: Array<CompetenceModel> = [];
  @Output() changed = new EventEmitter<Array<CompetenceModel>>();

  values: Array<ValueType> = [];

  faCheckSquare = faCheckSquare;
  faSquare = faSquare;

  constructor(
    public transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.values = [];
    this.competences.forEach((competence: CompetenceModel) => {
      this.values.push({
        competence,
        selected: (!Array.isArray(this.hidden) || this.hidden.indexOf(competence) === -1)
      });
    });
    this.values.sort((a: any, b: any) => (
      a.competence.position > b.competence.position) ? 1 : ((b.competence.position > a.competence.position) ? -1 : 0)
    );
  }

  onCompetenceClicked(value: ValueType): void {
    value.selected = !value.selected;
    this.emitHiddenCompetences();
  }

  private emitHiddenCompetences(): void {
    const hidden: Array<CompetenceModel> = [];
    this.values.forEach((value: ValueType) => {
      if (value.selected === false) {
        hidden.push(value.competence);
      }
    });
    this.changed.emit(hidden);
  }

}
